export default {"src":"/_next/static/media/countdown_background_1.948aed97.svg","height":60,"width":169,"blurWidth":0,"blurHeight":0};